// extracted by mini-css-extract-plugin
export default {"propertyCard":"PropertyCard_propertyCard__62zGS","propertyCardContent":"PropertyCard_propertyCardContent__bIhx1"};